import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { format } from 'date-fns';

const BlogCard = ({ post, featured = false }) => {
  const formattedDate = post.created_at 
    ? format(new Date(post.created_at), 'MMMM d, yyyy')
    : '';

  if (featured) {
    return (
      <Link
        to={`/blog/${post.slug}`}
        className="group block"
        data-testid={`blog-card-featured-${post.id}`}
      >
        <article className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="overflow-hidden rounded-sm aspect-[4/3] lg:aspect-[3/2]">
            <img
              src={post.featured_image || 'https://images.unsplash.com/photo-1681018754447-abe57371b5de?crop=entropy&cs=srgb&fm=jpg&q=85'}
              alt={post.title}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="flex flex-col gap-4">
            {post.category && (
              <span className="text-sm tracking-widest uppercase text-red-800 font-medium">
                {post.category}
              </span>
            )}
            <h2 className="font-serif text-3xl md:text-4xl text-stone-900 group-hover:text-red-800 transition-colors duration-300">
              {post.title}
            </h2>
            <p className="text-stone-600 leading-relaxed line-clamp-3">
              {post.excerpt}
            </p>
            <div className="flex items-center gap-4 text-stone-500 text-sm">
              <span className="flex items-center gap-2">
                <Calendar size={14} />
                {formattedDate}
              </span>
              <span>By {post.author_name}</span>
            </div>
            <span className="inline-flex items-center gap-2 text-stone-900 font-medium mt-2 group-hover:text-red-800 transition-colors">
              Read Story <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </span>
          </div>
        </article>
      </Link>
    );
  }

  return (
    <Link
      to={`/blog/${post.slug}`}
      className="group cursor-pointer flex flex-col gap-4"
      data-testid={`blog-card-${post.id}`}
    >
      <article>
        <div className="overflow-hidden rounded-sm aspect-[4/3]">
          <img
            src={post.featured_image || 'https://images.unsplash.com/photo-1681018754447-abe57371b5de?crop=entropy&cs=srgb&fm=jpg&q=85'}
            alt={post.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        </div>
        <div className="mt-5 flex flex-col gap-2">
          {post.category && (
            <span className="text-xs tracking-widest uppercase text-red-800 font-medium">
              {post.category}
            </span>
          )}
          <h3 className="font-serif text-xl md:text-2xl text-stone-900 group-hover:text-red-800 transition-colors duration-300 line-clamp-2">
            {post.title}
          </h3>
          <p className="text-stone-600 text-sm line-clamp-2 mt-1">
            {post.excerpt}
          </p>
          <div className="flex items-center gap-3 text-stone-500 text-xs mt-2">
            <Calendar size={12} />
            <span>{formattedDate}</span>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default BlogCard;
